

















import { Vue, Component } from 'vue-property-decorator'
import Header from '@/UI/App/Layout/Header/Header.vue'
import Footer from '@/UI/App/Layout/Footer/Footer.vue'
import Loader from '@/UI/App/Layout/Loader/Loader.vue'
import MessageAlert from '@/UI/App/Layout/MessageAlert/MessageAlert.vue'
import FullLeftMenu from '@/UI/App/Layout/LeftMenu/FullLeftMenu.vue'
import PageTitle from '@/UI/App/Layout/PageTitle/PageTitle.vue'

@Component({
  components: {
    Header,
    Loader,
    Footer,
    FullLeftMenu,
    PageTitle,
    MessageAlert
  }
})
export default class App extends Vue {
  get fullWidth (): boolean {
    if (!this || !this.$route || !this.$route.meta) {
      return false
    }
    return this.$route.meta.fullWidth || false
  }
}
